export const DETAILED_VIEW_LABEL = 'Detailed View';
export const STANDARD_VIEW_LABEL = 'Standard View';
export const DELETE_LABEL = 'Delete';
